export default __webpack_public_path__ + "static/media/challenge.5fe69d60.svg";